import { default as LetsWorkTogether } from './LetsWorkTogether';

export default LetsWorkTogether;
